export default __webpack_public_path__ + "static/char-s-31-en-f66f6da41b07e6de45f9015065977b8c.png";